/* eslint-disable no-nested-ternary */
import { StarRounded } from '@mui/icons-material';
import { Dialog } from '@mui/material';
import * as Sentry from '@sentry/react';
import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { ConnectedProps, connect } from 'react-redux';
import { Redirect } from 'react-router';
import {
    GOOGLE_STORAGE_API_CGA, LESSON_FILTERS, QUESTIONS_TYPES, REMARK_MAX_LENGTH, WEBEVOLUTIONS_SAFERPAY_SCHOOLS
} from '../../resources/constants';
import '../../resources/css/cart.css';
import { roundNumber } from '../../resources/utils';
import { readCart, writeCart } from '../../libs/cartStorage';
import axiosapi from '../../store/actions/axiosapi';
import { fetchSchools } from '../../store/actions/products';
import {
    getBCClient, getCountries, getInputClient, getLanguages, setInputClient
} from '../../store/actions/settings';
import { changeCart, openSignUpForm } from '../../store/actions/user';
import { ApplicationState, StoreDispatch } from '../../store/types';
import { LessonCart, Option, Question } from '../../types/booking';
import {
    CheckBookingRequest, LessonToBook, ParticipantRequest, TotalPriceRequest, TotalPriceResponse
} from '../../types/cart';
import { RouterProps } from '../../types/generalTypes';
import Authenticator from '../authenticator';
import Button from '../common/button';
import Container from '../common/container';
import LoadingCircle from '../common/loadingCircle';
import Snackbar from '../common/snackbar';
import Title from '../common/title';
import OrderApi from '../order/api/order_api';
import CartLesson from './cartLesson';
import DiscountModal from './discountModal';
import OrderSummary, { SummaryLine } from './orderSummary';
import SettingsModal from './settingsModal';

type ReduxProps = ConnectedProps<typeof connector>;

/**
 * Floor of the amount left to pay once every discount is applied: the payment
 * flow cannot handle a 0 CHF transaction, so discounts are trimmed to leave at
 * least this much. Drop it to 0 the day free orders are supported end to end.
 */
const MIN_TO_PAY = 1;

interface IProps {
    dispatch: StoreDispatch;
}

type Props = IProps & RouterProps & WrappedComponentProps & ReduxProps;

function toggleStateKey<T extends keyof State>(key: T, state: State, value?: boolean): Pick<State, T> {
    if (typeof state[key] === 'boolean') {
        if (value !== undefined) {
            return { [key]: value } as Pick<State, T>;
        }

        return { [key]: !state[key] } as Pick<State, T>;
    }
    throw new Error(`Property ${key} is not a boolean`);
}

interface State {
    sentryCustomerLoyalty: boolean;
    formatedItems: React.ReactNode;
    totalPrice: number;
    totalPriceBC?: TotalPriceResponse;
    payNow: boolean;
    hasNoUserData: boolean;
    accept: boolean;
    itemToDelete: any;
    // unavailableLessons: Lesson[];
    checking: boolean;
    familyDiscount: number;
    promoDiscount: number;
    subTotal: number;
    internetDiscount: number;
    openSettingsModal: boolean;
    openDiscountModal: boolean;
    discountSuccess: boolean;
    // anchorEl: any;
    checkFailed: boolean;
    checked: boolean;
    // inputClient: any;
    request?: CheckBookingRequest;
    fetchedInputClient: boolean;
    usePoints: boolean;
    errorMessage: string;
    // codeDiscount: any;
    codeDiscountDisplayError: boolean;
    codeDiscountAmount: any;
    codeDiscountCode: any;
    codeDiscountWait: number;
    codeDiscountDoAgain: boolean;
    coupon: {
        codeVerified?: boolean;
        code?: string;
        error: boolean;
        balance: number;
        value: number;
    };
    isParticipantError: boolean;
    displayParticipantError: boolean;
    loyaltyPointsToUse: number;
    couponAmountToUse: number;
    codeDiscountToUse: number;
    bookingCheckOnlyFailed?: boolean;
    validatingCartPrices: boolean;
}

class Cart extends React.Component<Props, State> {
    static codeDiscountRequest = async (
        client_id: string,
        code: string,
        level_id: string,
        lesson_id: number,
        lesson_from: string,
        lesson_to: string,
        lesson_duration_hours: number = 0.0,
        lesson_duration_days: number = 0.0,
        school__external_id: string | undefined = undefined
    ) => {
        const response = await axiosapi.get(`/code_discount/?client_id=${client_id}&school__external_id=${school__external_id}&code=${code}&level_id=${level_id}&lesson_id=${lesson_id}&lesson_from=${lesson_from}&lesson_to=${lesson_to}&lesson_duration_hours=${lesson_duration_hours}&lesson_duration_days=${lesson_duration_days}`);
        return response.data.results[0];
    };

    static timeToDecimal = (time: string): number => {
        let t = time;
        t += '';
        const arr = t.split('h');
        if (t.length < 2) return parseFloat(t);
        const dec = (parseInt(arr[1], 10) / 6) * 10;
        // const dec: any = parseInt((arr[1] / 6) * 10, 10); // KROK Removed parseInt()

        return parseFloat(`${parseInt(arr[0], 10)}.${dec < 10 ? '0' : ''}${dec}`);
    };

    static roundHalf = (num: number): number => Math.round(num * 2) / 2;

    static calculateTotalPrice = (currentCart: LessonCart[]) => {
        const totalPrice = currentCart.reduce((accumulator, currentValue) => accumulator + currentValue.price + (typeof currentValue.totalOptionsPrice === 'string' ? parseFloat(currentValue.totalOptionsPrice) : currentValue.totalOptionsPrice), 0);
        return totalPrice;
    };

    items: LessonCart[];

    constructor(props: Props) {
        super(props);

        const { intl } = this.props;

        this.state = {
            sentryCustomerLoyalty: false,
            formatedItems: [],
            totalPrice: 0, // total price
            totalPriceBC: undefined, // Booking Corner total price object
            payNow: false,
            hasNoUserData: false,
            accept: false,
            itemToDelete: null,
            // unavailableLessons: [],
            checking: false,
            familyDiscount: 0,
            internetDiscount: 0,
            promoDiscount: 0,
            subTotal: 0,
            openSettingsModal: false,
            openDiscountModal: false,
            discountSuccess: false,
            // anchorEl: undefined,
            checkFailed: false,
            checked: false,
            // inputClient: null,
            request: undefined,
            fetchedInputClient: false,
            usePoints: false,
            errorMessage: intl.formatMessage({ id: 'order.checkFailed' }),
            // codeDiscount: undefined,
            codeDiscountDisplayError: false,
            codeDiscountAmount: [],
            codeDiscountCode: undefined,
            codeDiscountWait: 0,
            codeDiscountDoAgain: false,
            coupon: {
                codeVerified: undefined,
                code: undefined,
                error: false,
                balance: 0.0,
                value: 0.0,
            },
            isParticipantError: false,
            displayParticipantError: false,
            loyaltyPointsToUse: 0,
            couponAmountToUse: 0,
            codeDiscountToUse: 0,
            validatingCartPrices: false,
        };

        this.items = [];

        this.handleClickDelete = this.handleClickDelete.bind(this);
        this.handleClickHome = this.handleClickHome.bind(this);
        this.formatItems = this.formatItems.bind(this);
        this.checkAccept = this.checkAccept.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    componentDidMount() {
        const {
            dispatch, languages, language, bcClient, countries, productSchools,
        } = this.props;
        document.getElementById('top')?.scrollIntoView();

        // accepted_payment_methods lives on store.products.schools; fetch it if the
        // user landed here without browsing products (e.g. hard refresh on /cart).
        if (!productSchools || productSchools.length === 0) {
            dispatch(fetchSchools());
        }

        if (Object.keys(languages).length === 0) {
            dispatch(getLanguages(language));
        }

        if (Object.keys(countries).length === 0) {
            dispatch(getCountries(language));
        }

        if (!bcClient && Authenticator.isLoggedIn()) {
            dispatch(getBCClient(language));
        }

        const currentCart: LessonCart[] = readCart();
        if (currentCart.length > 0) {
            this.items = currentCart;
            this.items.map((item, i) => {
                const itemx = item;
                itemx.checkId = i;
                return itemx;
            });
            const cdAmount = new Array(this.items.length).fill(0);
            this.setState({
                formatedItems: this.formatItems(currentCart),
                totalPrice: Cart.calculateTotalPrice(currentCart),
                codeDiscountAmount: cdAmount,
                validatingCartPrices: true,
            }, () => {
                this.validateCartPrices()
                    .finally(() => {
                        this.setState({ validatingCartPrices: false });
                    });
            });
        }
    }

    componentDidUpdate() {
        const {
            currentSchool,
            match,
            history,
            userData,
            bcClient,
            inputClient: inputClientProps,
            dispatch,
        } = this.props;
        const {
            checking, checked, checkFailed, fetchedInputClient, validatingCartPrices,
        } = this.state;
        // if the current school as not online purchase redirect to landing
        if (currentSchool && !currentSchool.online_purchase) {
            history.replace(`/${match.params.lang}/`);
        }

        if (this.items.length === 0) return;

        // if (codeDiscountUpdatePrice && codeDiscountCode) {
        //     this.setState({ codeDiscountUpdatePrice: false });
        //     this.checkBooking();
        // }

        if (
            !validatingCartPrices
            && !checking
            && !checked
            && !checkFailed
            && Object.keys(userData).length > 0
            && bcClient
        ) {
            this.setState({ checking: true }, () => this.checkBooking());
        }

        if (!inputClientProps && !fetchedInputClient) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const company_id = this.items[0].school_id.external_id;
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const { department_id } = this.items[0].school_id;
            this.setState({ fetchedInputClient: true }, () => {
                dispatch(getInputClient(company_id, department_id));
            });
        }
        /* else if (inputClientProps
            && Object.keys(inputClientProps).length > 0
            && !inputClientProps) {
            const inputClient: any = [];
            Object.keys(inputClient).forEach((key) => {
                if (key.includes("Required")
                && inputClient[key] === true) {
                    inputClient.push(key.replace("Required", "").toLowerCase());
                }
            });
            this.setState({ inputClient });
        } */
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(setInputClient(undefined));
    }

    /* Handler */

    handleClickDelete(event: any, item: any) {
        if (this.items.length > 0) {
            this.setState({
                itemToDelete: item,
                // anchorEl: event.currentTarget,
            });
        }
    }

    handleDelete() {
        const { dispatch } = this.props;
        const { codeDiscountAmount, itemToDelete } = this.state;
        const item = itemToDelete;
        const items = [...this.items];
        const index = items.indexOf(item);
        if (index > -1) {
            items.splice(index, 1);
            codeDiscountAmount.splice(index, 1);
        }
        this.items = items;
        // reconstruct formated Items otherwise bad references inside
        this.setState({
            codeDiscountAmount,
            formatedItems: [],
            totalPrice: Cart.calculateTotalPrice(items),
            itemToDelete: null,
            codeDiscountDoAgain: true,
        }, () => {
            this.setState({
                formatedItems: this.formatItems(items),
                checking: false,
                checked: false,
                checkFailed: false,
            });
        });

        writeCart(items);

        dispatch(changeCart());
    }

    handleClickHome() {
        const { history, match } = this.props;
        history.push(`/${match.params.lang}`);
    }

    handleClickOrder = () => {
        const { dispatch } = this.props;
        const { isParticipantError } = this.state;
        const isLoggedIn = Authenticator.isLoggedIn();
        if (isParticipantError) {
            this.setState({ displayParticipantError: true });
        } else if (isLoggedIn) {
            this.toggleOpenModal('openSettingsModal');
        } else {
            dispatch(openSignUpForm());
        }
    };

    handleSettingsCheck = async () => {
        const { userData } = this.props;
        const user = userData;
        const { request, coupon, couponAmountToUse } = this.state;
        if (request) {
            // const allUniqueParticipants: ParticipantRequest[] = [];
            // const participantGeneratedId = -1;
            request.Client = {
                CommonId: parseInt(user.cid, 10),
                Email: user.user.email,
                Name: user.user.last_name ? user.user.last_name : '',
                Firstname: user.user.first_name ? user.user.first_name : '',
                Address: user.address ? user.address : '',
                AddressLocal: user.address_local ? user.address_local : '',
                Zip: user.zip ? user.zip : '',
                Town: user.town ? user.town : '',
                Phone: user.phone ? user.phone : '',
                Mobile: user.phone ? user.phone : '',
                Sex: 'm',
                LanguageId: user.language,
                CountryId: user.country,
                // Participants: bcClient.Participants ? bcClient.Participants : [],
            };

            // request.Bookings.forEach((b) => {
            //     // allUniqueParticipants.push(b["Participants"]);
            //     const bookingg = b;
            //     bookingg.Participants = bookingg.Participants.map((p) => {
            //         const participantt = p;
            //         if (!Number.isNaN(participantt.Id) && (participantt.Id || 0) < 0) {
            //             const same = allUniqueParticipants.find(
            //                 (ap) => (
            //                     ap.Firstname?.toLowerCase() === participantt.firstname.toLowerCase()
            //                 && (participantt.name === undefined
            //                     || ap.Name?.toLowerCase() === participantt.name.toLowerCase())
            //                 ),
            //             );

            //             if (same) {
            //                 participantt.Id = same.Id;
            //                 participantt.p_id = participantt.Id;
            //             } else {
            //                 participantt.Id = (participantGeneratedId--).toString();
            //                 participantt.p_id = participantt.Id;
            //                 allUniqueParticipants.push(participantt);
            //             }
            //         }
            //         return participantt;
            //     });
            // });

            request.couponCode = coupon.codeVerified;
            // Effective amount computed by checkBooking(), not the raw balance:
            // the voucher can have been trimmed to keep MIN_TO_PAY on the order.
            request.couponAmount = couponAmountToUse;

            let response;
            try {
                response = await OrderApi.bookingCheckOnly(request);
            } catch (error) {
                if (axios.isAxiosError(error) && error.response?.status === 404) {
                    const lessonId = request.Bookings?.[0]?.lessonId;
                    this.setState({ openSettingsModal: false }, () => {
                        if (lessonId != null) this.disableUnavailableLesson(lessonId);
                    });
                    return;
                }
                this.setState({ bookingCheckOnlyFailed: true, openSettingsModal: false });
                return;
            }

            if (response.success) {
                this.setState(
                    { request, openSettingsModal: false },
                    () => this.setState({ payNow: true }),
                );
            } else {
                this.setState({ bookingCheckOnlyFailed: true, openSettingsModal: false });
            }
        }
    };

    /* Check booking */

    // checkBooking = async () => {
    //     const { currentSchool } = this.props;
    //     if (this.items.length <= 0) return;
    //     let participantGeneratedId = -1;
    //     const participantsGeneratedsId = [];

    //     const bookings = this.items.map((lesson, i) => {
    //         const fromTime = moment(lesson.time.from_time);
    //         const toTime = moment(lesson.time.to_time.time);

    //         return {
    //             lessonId: lesson.lesson_id,
    //             levelId: lesson.level.id,
    //             ProductId: lesson.external_id,
    //             ActivityId: lesson.activity_id,
    //             CategoryId: lesson.level.external_id,
    //             From: moment(lesson.date.from_date).set('hours', fromTime.hours()).set('minutes', fromTime.minutes()).set('seconds', fromTime.seconds())
    //                 .format('YYYY-MM-DDTHH:mm:ss'),
    //             To: moment(lesson.date.to_date).set('hours', toTime.hours()).set('minutes', toTime.minutes()).set('seconds', toTime.seconds())
    //                 .format('YYYY-MM-DDTHH:mm:ss'),
    //             MeetingPointId: lesson.meeting_point.id,
    //             NbDays: lesson.days,
    //             NbMinutes: toTime.diff(fromTime, 'minutes'),
    //             NbParticipants: lesson.participants,
    //             Participants: lesson.participants_infos.map((p) => {
    //                 Object.keys(p).map((k) => {
    //                     if (p[k].value) p[k] = p[k].value;
    //                     // if (!p.p_id && this.props.bcClient.Participants && this.props.bcClient.Participants.length > 0) {
    //                     //     let p_id = this.checkParticipant(p);
    //                     //     if (p_id) p.p_id = p_id;
    //                     // }
    //                 });
    //                 if (p.hasOwnProperty('p_id') && isNaN(p.Id)) {
    //                     p.Id = p.p_id;
    //                     // delete p["p_id"];
    //                 } else {
    //                     let gId;
    //                     for (const pgId of participantsGeneratedsId) {
    //                         if (pgId.Firstname.toLowerCase() === p.firstname.toLowerCase() && (p.name === undefined || pgId.Name.toLowerCase() === p.name.toLowerCase())) {
    //                             gId = pgId.Id;
    //                         }
    //                     }
    //                     if (gId === undefined) {
    //                         gId = (participantGeneratedId--).toString();
    //                         if (p.name) {
    //                             participantsGeneratedsId.push({ Id: gId, Firstname: p.firstname, Name: p.name });
    //                         } else {
    //                             participantsGeneratedsId.push({ Id: gId, Firstname: p.firstname });
    //                         }
    //                     }
    //                     p.Id = gId;
    //                     p.p_id = gId;
    //                 }
    //                 return p;
    //             }),
    //             Options: lesson.options.map((o) => ({ OptionId: o.id, Price: o.total, Quantity: o.qty < 0 ? undefined : o.qty })),
    //             Answers: lesson.questions ? lesson.questions.map((q) => {
    //                 const inputValue = (q.type === QUESTIONS_TYPES.DATE || q.type === QUESTIONS_TYPES.DATETIME || q.type === QUESTIONS_TYPES.TIME) ? undefined : q.answer.toString();
    //                 const dateTimeValue = (q.type === QUESTIONS_TYPES.DATE || q.type === QUESTIONS_TYPES.DATETIME || q.type === QUESTIONS_TYPES.TIME) ? q.answer : undefined;
    //                 if (dateTimeValue === undefined) {
    //                     return ({ QuestionId: q.id, Type: q.type, InputValue: inputValue });
    //                 }
    //                 return ({ QuestionId: q.id, Type: q.type, DateTimeValue: dateTimeValue });
    //             }) : [],
    //             Remark: lesson.remarks.length > 0 ? lesson.remarks : undefined,
    //             InstructorId: lesson.instructor ? lesson.instructor.Id : undefined,
    //             InstructorPriority: lesson.instructor ? lesson.instructor.priority : undefined,
    //             Price: lesson.price + lesson.totalOptionsPrice,
    //             checkId: lesson.checkId,
    //             SchoolId: lesson.school_id.external_id,
    //             DepartmentId: lesson.school_id.department_id,
    //         };
    //     });

    //     let loyaltyPoints = this.state.usePoints ? this.getLoyaltyPoints() : 0;
    //     const codeDiscount = this.amountCodeDiscount();
    //     // const loyaltyPoints = 0;

    //     const checkBookingRequest = {
    //         Bookings: bookings,
    //         FidelityDiscount: loyaltyPoints,
    //         CodeDiscount: codeDiscount,
    //         Account: 'BOOKING',
    //         TransactionType: 'VISA',
    //         CheckOnly: true,
    //     };

    //     const totalPriceRequest = {
    //         FidelityDiscount: loyaltyPoints,
    //         CouponAmount: this.state.coupon.balance,
    //         CodeDiscount: codeDiscount,
    //         Bookings: bookings,
    //     };

    //     // check booking
    //     const response = await OrderApi.checkBooking(checkBookingRequest);

    //     let totalPrice = await OrderApi.totalPrice(totalPriceRequest, this.props.language);
    //     if (loyaltyPoints > 0 && totalPrice.ToPay < 0) {
    //         loyaltyPoints += (totalPrice.ToPay - 1);
    //         totalPriceRequest.FidelityDiscount = loyaltyPoints;
    //         checkBookingRequest.FidelityDiscount = loyaltyPoints;
    //         totalPrice = await OrderApi.totalPrice(totalPriceRequest, this.props.language);
    //     }

    //     checkBookingRequest.TotalPrice = totalPrice.Sum;
    //     checkBookingRequest.TransactionPrice = totalPrice.ToPay;

    //     if (response.checkIds && response.checkIds.length > 0) {
    //         this.checkFailed(response.checkIds);
    //     }
    //     if (response.globalId) {
    //         this.setState({ checkFailed: true, checking: false, errorMessage: this.getErrorMessage(response) });
    //     } else {
    //         this.setState({
    //             loyaltyPointsToUse: loyaltyPoints,
    //             request: checkBookingRequest,
    //             checking: false,
    //             checkFailed: false,
    //             checked: true,
    //             subTotal: totalPrice.Sum,
    //             familyDiscount: totalPrice.FamilyDiscount,
    //             internetDiscount: totalPrice.InternetDiscount,
    //             promoDiscount: totalPrice.PromoDiscount,
    //             totalPrice: totalPrice.ToPay
    //         }, () => {
    //             // TODO: Custom code to Anzere (Passeport Vacances APA) !IMPORTANT => Désactiver pour l'hiver
    //             if (currentSchool !== undefined && currentSchool.int_id === '11' && this.state.codeDiscountDoAgain) {
    //                 this.setState({ codeDiscountDoAgain: false }, () => this.checkBooking());
    //             }
    //         });
    //     }

    //     this.setState({ totalPriceBC: totalPrice });
    // };

    checkBooking = async () => {
        const { usePoints, coupon, codeDiscountDoAgain } = this.state;
        const { currentSchool, language, intl } = this.props;
        if (this.items.length <= 0) return;
        let participantGeneratedId = -1;
        const participantsGeneratedsId: ParticipantRequest[] = [];
        const bookings: LessonToBook[] = this.items.map((lesson) => {
            const fromTime = moment(lesson.time.from_time);
            const toTime = moment(lesson.time.to_time.time);

            return {
                lessonId: lesson.lesson_id,
                levelId: lesson.level?.id,
                ProductId: lesson.external_id,
                ActivityId: lesson.activity_id,
                CategoryId: lesson.level?.external_id,
                From: moment(lesson.date.from_date).set('hours', fromTime.hours()).set('minutes', fromTime.minutes()).set('seconds', fromTime.seconds())
                    .format('YYYY-MM-DDTHH:mm:ss'),
                To: moment(lesson.date.to_date).set('hours', toTime.hours()).set('minutes', toTime.minutes()).set('seconds', toTime.seconds())
                    .format('YYYY-MM-DDTHH:mm:ss'),
                MeetingPointId: lesson.meeting_point.id,
                NbDays: lesson.days,
                NbMinutes: toTime.diff(fromTime, 'minutes'),
                NbParticipants: Number(lesson.participants),
                Participants: lesson.participants_infos.map((participant) => {
                    const p = participant;

                    Object.keys(p).forEach((k) => {
                        if (p[k].value) p[k] = p[k].value;
                        // if (!p.p_id && this.props.bcClient.Participants && this.props.bcClient.Participants.length > 0) {
                        //     let p_id = this.checkParticipant(p);
                        //     if (p_id) p.p_id = p_id;
                        // }
                    });
                    if (Object.prototype.hasOwnProperty.call(p, 'p_id') && isNaN(p.Id)) {
                        p.Id = p.p_id;
                        // delete p["p_id"];
                    } else {
                        let gId;
                        for (const pgId of participantsGeneratedsId) {
                            if (pgId.Firstname?.toLowerCase() === p.firstname.toLowerCase() && (p.name === undefined || pgId.Name?.toLowerCase() === p.name.toLowerCase())) {
                                gId = pgId.Id;
                            }
                        }
                        if (gId === undefined) {
                            gId = (participantGeneratedId--).toString();
                            if (p.name) {
                                participantsGeneratedsId.push({ Id: gId, Firstname: p.firstname, Name: p.name });
                            } else {
                                participantsGeneratedsId.push({ Id: gId, Firstname: p.firstname });
                            }
                        }
                        p.Id = gId;
                        p.p_id = gId;
                    }
                    return p;
                }),
                Options: lesson.options.map((o: Option) => ({
                    OptionId: o.id,
                    Price: (typeof o.total === 'string' ? parseFloat(o.total) : o.total),
                    Quantity: o.qty < 0 ? undefined : o.qty,
                })),
                Answers: lesson.questions ? lesson.questions.map((q: Question) => {
                    const inputValue = (q.type === QUESTIONS_TYPES.DATE
                        || q.type === QUESTIONS_TYPES.DATETIME
                        || q.type === QUESTIONS_TYPES.TIME)
                        ? undefined : q.answer?.toString();
                    const dateTimeValue = (q.type === QUESTIONS_TYPES.DATE
                        || q.type === QUESTIONS_TYPES.DATETIME
                        || q.type === QUESTIONS_TYPES.TIME)
                        ? q.answer : undefined;
                    if (dateTimeValue === undefined) {
                        return ({ QuestionId: q.id, Type: q.type, InputValue: inputValue });
                    }
                    return ({ QuestionId: q.id, Type: q.type, DateTimeValue: dateTimeValue });
                }) : [],
                Remark: lesson.remarks.length > 0 ? lesson.remarks.slice(0, REMARK_MAX_LENGTH) : undefined,
                InstructorId: lesson.instructor ? lesson.instructor.Id : undefined,
                InstructorPriority: lesson.instructor ? lesson.instructor.priority : undefined,
                Price: lesson.price + (typeof lesson.totalOptionsPrice === 'string' ? parseFloat(lesson.totalOptionsPrice) : lesson.totalOptionsPrice),
                checkId: lesson.checkId,
                SchoolId: lesson.school_id.external_id,
                DepartmentId: lesson.school_id.department_id,
            };
        });

        // The three manual discounts stack. `getLoyaltyPoints()` returns undefined
        // when the customer has no (or a duplicated) loyalty record, hence the || 0.
        let loyaltyPoints = (usePoints ? this.getLoyaltyPoints() : 0) || 0;
        let codeDiscount = this.amountCodeDiscount();
        let couponAmount = coupon.balance;

        const checkBookingRequest: CheckBookingRequest = {
            Bookings: bookings,
            FidelityDiscount: loyaltyPoints,
            CodeDiscount: codeDiscount,
            Account: 'BOOKING',
            TransactionType: 'VISA',
            CheckOnly: true,
        };

        const totalPriceRequest: TotalPriceRequest = {
            FidelityDiscount: loyaltyPoints,
            CouponAmount: couponAmount,
            CodeDiscount: codeDiscount,
            Bookings: bookings,
        };

        // check booking
        let response;
        try {
            response = await OrderApi.checkBooking(checkBookingRequest);
        } catch (error) {
            if (axios.isAxiosError(error) && error.response?.status === 404) {
                this.disableUnavailableLesson(bookings[0].lessonId);
                return;
            }
            this.setState({ checkFailed: true, checking: false });
            return;
        }

        let totalPrice: TotalPriceResponse;
        try {
            totalPrice = await OrderApi.totalPrice(totalPriceRequest, language);
        } catch {
            this.setState({ checkFailed: true, checking: false });
            await this.validateCartPrices();
            return;
        }

        // Discounts are applied in a fixed order - code, then loyalty points, then
        // gift voucher - so a given basket always resolves to the same amounts,
        // whatever order the customer entered them in. Payment cannot go through
        // for 0, so the total is floored at MIN_TO_PAY and the overflow is absorbed
        // in the reverse order: the voucher keeps its unused balance, then the
        // points stay on the account, and the one-shot code is trimmed last since
        // whatever it does not cover here is lost for the customer anyway.
        if (couponAmount + loyaltyPoints + codeDiscount > 0 && totalPrice.ToPay < MIN_TO_PAY) {
            let excess = roundNumber(MIN_TO_PAY - totalPrice.ToPay);
            const absorb = (amount: number) => {
                const taken = Math.min(Math.max(amount, 0), excess);
                excess = roundNumber(excess - taken);
                return roundNumber(amount - taken);
            };
            couponAmount = absorb(couponAmount);
            loyaltyPoints = absorb(loyaltyPoints);
            codeDiscount = absorb(codeDiscount);

            totalPriceRequest.FidelityDiscount = loyaltyPoints;
            totalPriceRequest.CouponAmount = couponAmount;
            totalPriceRequest.CodeDiscount = codeDiscount;
            checkBookingRequest.FidelityDiscount = loyaltyPoints;
            checkBookingRequest.CodeDiscount = codeDiscount;
            try {
                totalPrice = await OrderApi.totalPrice(totalPriceRequest, language);
            } catch {
                this.setState({ checkFailed: true, checking: false });
                await this.validateCartPrices();
                return;
            }
        }

        checkBookingRequest.TotalPrice = totalPrice.Sum;
        checkBookingRequest.TransactionPrice = totalPrice.ToPay;

        if (response.checkIds && response.checkIds.length > 0) {
            this.checkFailed(response.checkIds);
        }
        if (response.globalId) {
            this.setState({
                checkFailed: true,
                checking: false,
                errorMessage: this.getErrorMessage(response),
            });
        } else {
            this.setState({
                loyaltyPointsToUse: roundNumber(loyaltyPoints),
                couponAmountToUse: roundNumber(couponAmount),
                codeDiscountToUse: roundNumber(codeDiscount),
                request: checkBookingRequest,
                checking: false,
                checkFailed: false,
                checked: true,
                subTotal: totalPrice.Sum,
                familyDiscount: roundNumber(totalPrice.FamilyDiscount),
                internetDiscount: roundNumber(totalPrice.InternetDiscount),
                promoDiscount: roundNumber(totalPrice.PromoDiscount),
                totalPrice: roundNumber(totalPrice.ToPay),
            }, () => {
                // TODO: Custom code to Anzere (Passeport Vacances APA)
                // !IMPORTANT => Désactiver pour l'hiver
                if (currentSchool !== undefined && currentSchool.int_id === '11' && codeDiscountDoAgain) {
                    this.setState({ codeDiscountDoAgain: false }, () => this.checkBooking());
                }
            });
        }

        this.setState({ totalPriceBC: totalPrice });
    };

    disableUnavailableLesson = (lessonId: number) => {
        this.items = this.items.map((item) => {
            if (item.lesson_id === lessonId) {
                return { ...item, disabled: true };
            }
            return item;
        });

        this.setState({
            formatedItems: this.formatItems(this.items),
            checkFailed: true,
            checking: false,
        });
    };

    /**
     * Call the individual price endpoint for each cart item to verify that
     * Booking Corner still has a valid price.  Only an explicit
     * `price_undefined` response marks a lesson — network errors, 400s and
     * 500s are ignored so they don't wrongly grey-out a lesson.
     */
    validateCartPrices = async (): Promise<void> => {
        let hasInvalid = false;

        const checks = this.items.map(async (item) => {
            const fromTime = moment(item.time.from_time);
            const toTime = moment(item.time.to_time.time);
            const body = {
                lessonId: item.lesson_id,
                levelId: item.level?.id,
                fromDate: moment(item.date.from_date).format('YYYY-MM-DD'),
                toDate: moment(item.date.to_date).format('YYYY-MM-DD'),
                startTime: fromTime.format('[0001-01-01T]HH:mm:ss'),
                endTime: toTime.format('[0001-01-01T]HH:mm:ss'),
                nbDays: item.days,
                nbParticipants: item.participants,
            };

            try {
                const response = await axiosapi.post('/booking-corner/price/', body);
                return response.data === 'price_undefined';
            } catch {
                return false;
            }
        });

        const results = await Promise.all(checks);
        results.forEach((priceGone, i) => {
            if (priceGone) {
                this.items[i] = { ...this.items[i], priceUnavailable: true, disabled: true };
                hasInvalid = true;
            }
        });

        if (hasInvalid) {
            const { intl } = this.props;
            this.setState({
                formatedItems: this.formatItems(this.items),
                checkFailed: true,
                errorMessage: intl.formatMessage({ id: 'cart.reasonPriceUnavailable' }),
            });
        }
    };

    checkFailed = (checkIds: number[]) => {
        this.items = this.items.map((itemx, i) => {
            const item = itemx;
            let bool = false;
            for (let j = 0; j < checkIds.length; ++j) {
                if (checkIds[j] === i) {
                    bool = true;
                    break;
                }
            }
            if (bool) {
                item.disabled = true;
            }
            return item;
        });

        this.setState({
            formatedItems: this.formatItems(this.items),
            checkFailed: true,
            checking: false,
        });
    };

    getErrorMessage = (response: any) => {
        const { intl } = this.props;
        if (response.reason) {
            const split = response.reason.split(' ');
            const message = `${split[1]} ${split[2]}`;
            return intl.formatMessage({ id: 'order.checkFailedWithInstructor' }, { instructor: message });
        }
        return intl.formatMessage({ id: 'order.checkFailed' });
    };

    /**
     * Removing an applied discount. Only the three manual ones can be removed:
     * family / internet / promo are computed by Booking Corner from the basket
     * itself, there is nothing to take back. Each removal re-runs checkBooking()
     * so the total and the remaining discounts are recomputed together.
     */
    removeCoupon = () => {
        this.setState((state) => ({
            coupon: {
                ...state.coupon, codeVerified: undefined, code: undefined, balance: 0.0, value: 0.0, error: false,
            },
            couponAmountToUse: 0,
            checking: true,
        }), () => this.checkBooking());
    };

    removeCodeDiscount = () => {
        this.setState({
            codeDiscountCode: undefined,
            codeDiscountAmount: [],
            codeDiscountWait: 0,
            codeDiscountDisplayError: false,
            codeDiscountToUse: 0,
            checking: true,
        }, () => this.checkBooking());
    };

    toggleUsePoints = () => {
        this.setState((state) => {
            const usePoints = !state.usePoints;
            return {
                usePoints,
                checking: true,
                // Applying from the modal closes it; removing keeps it open, since
                // the customer is most likely about to enter something else.
                openDiscountModal: usePoints ? false : state.openDiscountModal,
                loyaltyPointsToUse: usePoints ? (this.getLoyaltyPoints() || 0) : 0,
                // Only when the points are being applied: they can also be removed
                // from the summary, and "Rabais appliqué" would be a lie then.
                discountSuccess: usePoints,
            };
        }, () => this.checkBooking());
    };

    /* Other */

    toggleOpenModal = (name: string) => this.setState(
        (state) => toggleStateKey(name as keyof State, state),
    );

    goHome = () => {
        const { history, language } = this.props;
        history.push(`/${language}/products`);
    };

    getLoyaltyPoints = () => {
        const { userData } = this.props;
        const { sentryCustomerLoyalty } = this.state;
        let schoolId: string;
        if (this.items.length > 0) {
            schoolId = this.items[0].school_id.external_id;
        }
        // get customer loyalty
        const customerLoyalty = userData.customerLoyalty ? userData.customerLoyalty.filter(
            (c: any) => c.schoolId === schoolId,
        ) : undefined;
        if (customerLoyalty !== undefined && customerLoyalty.length === 1) {
            const { points } = customerLoyalty[0];
            // if there are more points than the total price,
            // set the points reduction to the total price
            // if(totalPrice < 0) {
            //     points += totalPrice;
            // }
            // if (points > totalPrice) {
            //     points = totalPrice;
            // }
            return points;
        } if (customerLoyalty !== undefined
            && customerLoyalty.length > 1
            && sentryCustomerLoyalty === false) {
            this.setState({ sentryCustomerLoyalty: true }, () => {
                Sentry.captureMessage(`Double Loyalty user ${userData?.user?.id}, school ${schoolId}`);
            });
            return undefined;
        }
        return undefined;
    };

    couponRequest = (value: any) => {
        const { currentSchool } = this.props;
        const { coupon } = this.state;
        OrderApi.coupon({
            schoolId: currentSchool?.int_id,
            departmentId: currentSchool?.department_id,
            code: value,
        })
            .then((response) => {
                if (response.balance > 0) {
                    coupon.error = false;
                    coupon.codeVerified = value;
                    coupon.value = response.value;
                    coupon.balance = response.balance;
                    this.setState({
                        coupon,
                        // Optimistic: the line shows the balance immediately, then
                        // checkBooking() replaces it with the effective amount.
                        couponAmountToUse: response.balance,
                        openDiscountModal: false,
                        discountSuccess: true,
                        checking: true,
                    }, () => this.checkBooking());
                } else {
                    coupon.error = true;
                    coupon.balance = 0.0;
                    coupon.value = 0.0;
                    coupon.codeVerified = undefined;
                    this.setState({ coupon }, () => this.checkBooking());
                }
            })
            .catch(() => {
                coupon.error = true;
                coupon.balance = 0.0;
                coupon.value = 0.0;
                coupon.codeVerified = undefined;
                this.setState({ coupon }, () => this.checkBooking());
            });
    };

    applyCodeDiscount = (value: string) => {
        const { userData, currentSchool } = this.props;

        const { codeDiscountAmount } = this.state;
        this.items.map(async (lesson, i) => {
            let lessonHours = 0.0;

            if (lesson.lesson_type === LESSON_FILTERS.GROUP_LESSON && typeof lesson.hours !== 'string') {
                lessonHours = Cart.timeToDecimal(String(lesson.hours.totalHoursLesson));
            } else if (typeof lesson.hours === 'string') {
                lessonHours = Cart.timeToDecimal(lesson.hours);
            }

            const discount = await Cart.codeDiscountRequest(
                userData.user.id,
                value,
                lesson.level?.id,
                lesson.lesson_id,
                moment(lesson.date.from_date).set('hours', moment(lesson.time.from_time).hours()).set('minutes', moment(lesson.time.from_time).minutes()).set('seconds', moment(lesson.time.from_time).seconds())
                    .format('YYYY-MM-DDTHH:mm:ss'),
                moment(lesson.date.to_date).set('hours', moment(lesson.time.to_time.time).hours()).set('minutes', moment(lesson.time.to_time.time).minutes()).set('seconds', moment(lesson.time.to_time.time).seconds())
                    .format('YYYY-MM-DDTHH:mm:ss'),
                lessonHours,
                lesson.days,
                currentSchool ? currentSchool.int_id.toString() : undefined,
            );

            codeDiscountAmount[i] = discount;
            if (discount) {
                this.setState((state) => ({
                    codeDiscountCode: discount.code ? discount.code : state.codeDiscountCode,
                    checking: true,
                    codeDiscountAmount,
                    codeDiscountToUse: this.amountCodeDiscount(),
                    codeDiscountDisplayError: true,
                    codeDiscountWait: state.codeDiscountWait + 1
                }), () => {
                    const { codeDiscountWait } = this.state;

                    if (codeDiscountWait === this.items.length) {
                        this.checkBooking();
                        this.setState((stateX) => ({
                            codeDiscountWait: 0,
                            openDiscountModal: !stateX.codeDiscountCode,
                            discountSuccess: !!stateX.codeDiscountCode
                        }));
                    }
                });
            } else {
                this.setState((state) => ({
                    checking: true,
                    codeDiscountAmount,
                    codeDiscountDisplayError: true,
                    codeDiscountWait: state.codeDiscountWait + 1
                }), () => {
                    const { codeDiscountWait } = this.state;

                    if (codeDiscountWait === this.items.length) {
                        this.checkBooking();
                        this.setState((stateX) => ({
                            codeDiscountWait: 0,
                            openDiscountModal: !stateX.codeDiscountCode,
                            discountSuccess: !!stateX.codeDiscountCode
                        }));
                    }
                });
            }
        });
    };

    amountCodeDiscount = () => {
        const { codeDiscountAmount, familyDiscount } = this.state;
        const { currentSchool } = this.props;
        let amount = 0.0;

        codeDiscountAmount.forEach((cd: any, i: number) => {
            if (cd && cd.amount) {
                amount += cd.amount;
            } else if (cd && cd.percent) {
                // TODO: Custom code to Anzere (Passeport Vacances APA)
                // !IMPORTANT => Désactiver pour l'hiver
                if (currentSchool !== undefined && currentSchool.int_id === '11') {
                    const nbElements = this.items.length;
                    let discountByElements = 0;
                    if (nbElements !== 0) {
                        discountByElements = familyDiscount / (nbElements * 1.0);
                    }
                    amount += parseFloat((((
                        this.items[i].price - discountByElements) * cd.percent) / 100.0
                    ).toFixed(2));
                } else {
                    amount += parseFloat(((this.items[i].price * cd.percent) / 100.0).toFixed(2));
                }
            }
        });

        // TODO: Custom code to Anzere (Passeport Vacances APA)
        // !IMPORTANT => Désactiver pour l'hiver
        if (currentSchool !== undefined && currentSchool.int_id === '11') {
            return Cart.roundHalf(amount);
        }

        return Math.round(amount * 100) / 100;
    };

    resetErrorCoupon = () => {
        const { coupon } = this.state;
        if (coupon.error) {
            coupon.error = false;
            this.setState({ coupon });
        }
    };

    resetErrorDiscount = () => {
        const { codeDiscountDisplayError } = this.state;
        if (codeDiscountDisplayError) {
            this.setState({ codeDiscountDisplayError: false });
        }
    };

    checkAccept() {
        this.setState((state) => ({ accept: !state.accept }));
    }

    formatItems(lessons: LessonCart[]) {
        let isParticipantError = false;
        const tmpLessons = lessons.map((lesson, idx) => {
            const i = idx;
            lesson.participants_infos.length !== lesson.participants && (isParticipantError = true);
            return (
                <CartLesson
                    key={`item_${i}`}
                    lesson={lesson}
                    type={lesson.lesson_type}
                    onDelete={this.handleClickDelete}
                    disabled={lesson.disabled || false}
                />
            );
        });
        this.setState({ isParticipantError });

        return tmpLessons;
    }

    renderSummary(checkBoxLabel: React.ReactNode, loyaltyPoints: any) {
        const {
            intl, schools, productSchools, bcClient,
        } = this.props;
        const {
            subTotal, familyDiscount, internetDiscount, promoDiscount,
            codeDiscountCode, coupon, usePoints, loyaltyPointsToUse,
            couponAmountToUse, codeDiscountToUse,
            totalPriceBC, totalPrice, accept, checking, checkFailed,
            checked, hasNoUserData,
        } = this.state;

        // `accepted_payment_methods` only exists on store.products.schools (raw GET /schools/),
        // joined to the cart item via external_id (== company int_id). store.setting.schools is
        // the lighter company list and has no payment methods.
        const item0 = this.items[0];
        const extId = item0?.school_id?.external_id;
        const bookedSchool = (productSchools || []).find(
            (s: any) => String(s.external_id) === String(extId) || (item0 && s.id === item0.school_id.id),
        );

        const lines: SummaryLine[] = [];
        if (subTotal > 0) {
            lines.push({ key: 'subtotal', label: intl.formatMessage({ id: 'order.subTotal' }), value: `CHF ${subTotal.toFixed(2)}` });
        }
        if (familyDiscount > 0) {
            lines.push({
                key: 'family',
                discount: true,
                label: totalPriceBC && totalPriceBC.FamilyDiscountText ? totalPriceBC.FamilyDiscountText : intl.formatMessage({ id: 'order.familyDiscount' }),
                value: `– ${familyDiscount.toFixed(2)} CHF`,
            });
        }
        if (internetDiscount > 0) {
            lines.push({
                key: 'internet',
                discount: true,
                label: totalPriceBC && totalPriceBC.InternetDiscountText ? totalPriceBC.InternetDiscountText : intl.formatMessage({ id: 'order.internetDiscount' }),
                value: `– ${internetDiscount.toFixed(2)} CHF`,
            });
        }
        if (promoDiscount > 0) {
            lines.push({
                key: 'promo',
                discount: true,
                label: totalPriceBC && totalPriceBC.PromoDiscountText ? totalPriceBC.PromoDiscountText : intl.formatMessage({ id: 'order.promoDiscount' }),
                value: `– ${promoDiscount.toFixed(2)} CHF`,
            });
        }
        // The three manual discounts below are cumulative and each carries its own
        // cross. They display the *effective* amount returned by checkBooking(),
        // which can be lower than the code / voucher / points face value once the
        // total has been floored at MIN_TO_PAY.
        //
        // Their labels stay ours, unlike the automatic discounts above: Booking
        // Corner only returns its own wording once the discount is part of the
        // priced request, so reading it here would make the label flip ("Points de
        // fidélité" then "Rabais fidélité") between the click and the response.
        // Nothing is lost - BC's text for these three carries no information the
        // customer does not already have, the code / voucher being shown verbatim.
        const removeLabel = intl.formatMessage({ id: 'cart.removeDiscount' });
        if (codeDiscountCode) {
            lines.push({
                key: 'code',
                discount: true,
                label: `${intl.formatMessage({ id: 'order.codeDiscount' })} ${codeDiscountCode}`,
                value: `– ${codeDiscountToUse.toFixed(2)} CHF`,
                onRemove: this.removeCodeDiscount,
                removeLabel,
            });
        }
        if (coupon.codeVerified) {
            lines.push({
                key: 'coupon',
                discount: true,
                label: `${intl.formatMessage({ id: 'order.placeholderCoupon' })} ${coupon.codeVerified}`,
                value: `– ${couponAmountToUse.toFixed(2)} CHF`,
                onRemove: this.removeCoupon,
                removeLabel,
            });
        }
        if (usePoints) {
            lines.push({
                key: 'loyalty',
                discount: true,
                label: intl.formatMessage({ id: 'order.loyaltyPoints' }),
                value: `– ${loyaltyPointsToUse.toFixed(2)} CHF`,
                onRemove: this.toggleUsePoints,
                removeLabel,
            });
        }

        // The banner doubles as the shortcut to apply the points: no need to go
        // through the discount modal, the button applies them directly. Once
        // applied it is the summary line that carries the removal cross, like the
        // two other manual discounts, so the banner keeps a single purpose.
        const appliedLoyaltyPoints = usePoints ? loyaltyPointsToUse : 0;

        const belowCard = (
            <>
                {
                    loyaltyPoints > 0 && (
                        <div className={`__cart-loyalty-banner${usePoints ? ' __cart-loyalty-banner-on' : ''}`}>
                            <StarRounded />
                            <span className="__cart-loyalty-text">
                                {
                                    appliedLoyaltyPoints > 0
                                        ? intl.formatMessage(
                                            { id: 'cart.loyaltyBannerApplied' },
                                            {
                                                points: appliedLoyaltyPoints,
                                                amount: Number(appliedLoyaltyPoints).toFixed(2),
                                            },
                                        )
                                        : intl.formatMessage(
                                            { id: 'cart.loyaltyBannerAvailable' },
                                            {
                                                points: loyaltyPoints,
                                                amount: Number(loyaltyPoints).toFixed(2),
                                            },
                                        )
                                }
                            </span>
                            {
                                !usePoints && (
                                    <button
                                        type="button"
                                        className="__cart-loyalty-action"
                                        disabled={checking || !bcClient}
                                        onClick={this.toggleUsePoints}
                                    >
                                        {intl.formatMessage({ id: 'cart.loyaltyActivate' })}
                                    </button>
                                )
                            }
                        </div>
                    )
                }
                {
                    this.items.length > 0 && (
                        <div className="__cart-notice __cart-notice-info">
                            {
                                WEBEVOLUTIONS_SAFERPAY_SCHOOLS.indexOf(parseInt(this.items[0].school_id.external_id, 10)) < 0 && (
                                    <p>{`${intl.formatMessage({ id: 'order.important2' })} Booking Corner`}</p>
                                )
                            }
                            <p>{intl.formatMessage({ id: 'order.important5' })}</p>
                            <p>{intl.formatMessage({ id: 'order.important4' })}</p>
                        </div>
                    )
                }
            </>
        );

        return (
            <OrderSummary
                title={intl.formatMessage({ id: 'booking.summary' })}
                lines={lines}
                totalLabel={intl.formatMessage({ id: 'cart.totalToPay' })}
                totalValue={`CHF ${totalPrice.toFixed(2)}`}
                vatLabel={intl.formatMessage({ id: 'cart.vatIncluded' })}
                addCode={{
                    label: intl.formatMessage({ id: 'cart.addCode' }),
                    // Discounts stack, so the entry point only closes once the three
                    // manual ones are applied - there is nothing left to add then.
                    disabled: coupon.codeVerified !== undefined && codeDiscountCode !== undefined && usePoints,
                    onClick: () => this.setState({ openDiscountModal: true }),
                }}
                checkBoxLabel={checkBoxLabel}
                accept={accept}
                onAcceptChange={this.checkAccept}
                onPay={this.handleClickOrder}
                payLoading={hasNoUserData || checking}
                payDisabled={
                    !accept
                    || hasNoUserData
                    || schools.length <= 0
                    || checking
                    || checkFailed
                    || (!checked && Authenticator.isLoggedIn() !== undefined)
                }
                payLabel={intl.formatMessage({ id: checking ? 'order.checking' : 'order.pay' })}
                onContinue={this.goHome}
                continueLabel={intl.formatMessage({ id: 'order.continueShop' })}
                belowCard={belowCard}
                acceptedPaymentMethods={bookedSchool?.accepted_payment_methods}
            />
        );
    }

    render() {
        const {
            userData, schools, history, intl, currentSchool, match, bcClient, language,
        } = this.props;
        const loyaltyPoints = this.getLoyaltyPoints();
        const {
            loyaltyPointsToUse,
            payNow,
            checkFailed,
            totalPrice,
            displayParticipantError,
            request,
            usePoints,
            codeDiscountCode,
            openSettingsModal,
            checked,
            coupon,
            checking,
            codeDiscountDisplayError,
            openDiscountModal,
            itemToDelete,
            discountSuccess,
            errorMessage,
            bookingCheckOnlyFailed,
            formatedItems,
            codeDiscountToUse,
            couponAmountToUse,
        } = this.state;
        // const loyaltyPoints = 0;

        // go to order init page if payNow is true
        if (payNow) {
            if (Object.keys(userData).length === 0) {
                this.setState({ hasNoUserData: true });
            } else {
                return (
                    <Redirect
                        push
                        to={{
                            pathname: `/${match.params.lang}/order/init`,
                            state: {
                                request,
                                email: userData.user.email,
                                points: usePoints ? loyaltyPointsToUse : 0,
                                codeDiscountAmount: codeDiscountToUse,
                                codeDiscountCode,
                                clientId: userData && userData.user ? userData.user.id : '',
                            },
                        }}
                    />
                );
            }
        }

        let tncPath: string | undefined;
        if (this.items.length > 0) {
            const tncSchools = schools.filter((s) => s.int_id === this.items[0].school_id.external_id);
            tncPath = tncSchools.length > 0 ? tncSchools[0].tnc_path : undefined;
        }

        const checkBoxLabel = this.items.length > 0 && schools.length > 0 ? (
            <span className="__cart-checkbox-label">
                {intl.formatMessage({ id: 'order.checkBoxMessage1' })}
                <a
                    href={tncPath}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => { e.stopPropagation(); e.preventDefault(); window.open(tncPath, '_blank', 'noopener,noreferrer'); }}
                >
                    {intl.formatMessage({ id: 'help.cga' })}
                </a>
                {intl.formatMessage({ id: 'order.checkBoxMessage2' })}
                <a
                    href={`${GOOGLE_STORAGE_API_CGA}Reglement-General-sur-la-Protection-des-Donnees.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => { e.stopPropagation(); e.preventDefault(); window.open(`${GOOGLE_STORAGE_API_CGA}Reglement-General-sur-la-Protection-des-Donnees.pdf`, '_blank', 'noopener,noreferrer'); }}
                >
                    {intl.formatMessage({ id: 'order.jdpr' })}
                </a>
                <span className="__cga-toline">
                    {intl.formatMessage({ id: 'order.checkBoxMessage3' }, { amount: totalPrice.toFixed(2) })}
                </span>
            </span>
        ) : <LoadingCircle />;

        let currentSchoolName = '';

        if (currentSchool) {
            currentSchoolName = currentSchool.name;
        } else if (this.items[0]) {
            currentSchoolName = this.items[0].school_id.name;
        }
        return (
            <Container
                headerBase={`${intl.formatMessage({ id: 'header.cart' })} → ${currentSchoolName}`}
            >
                <div className="__cart-parent">
                    {
                        openSettingsModal
                        && (
                            <SettingsModal
                                open={openSettingsModal}
                                onClose={() => this.toggleOpenModal('openSettingsModal')}
                                onCheck={this.handleSettingsCheck}
                                buttonText={intl.formatMessage({ id: checked ? 'order.pay' : 'order.check' })}
                            />
                        )
                    }
                    <DiscountModal
                        checkCoupon={this.couponRequest}
                        // A given type can only be applied once: the customer has to
                        // remove the code / voucher / points from the summary before
                        // entering another one. Different types do stack.
                        disabledCoupon={checking || !bcClient || coupon.codeVerified !== undefined}
                        errorCoupon={coupon.error && !coupon.codeVerified}
                        resetErrorCoupon={this.resetErrorCoupon}
                        checkDiscount={this.applyCodeDiscount}
                        disabledDiscount={checking || !bcClient || codeDiscountCode !== undefined}
                        errorDiscount={codeDiscountDisplayError && !codeDiscountCode}
                        resetErrorDiscount={this.resetErrorDiscount}
                        checkFidelity={this.toggleUsePoints}
                        disabledFidelity={
                            checking
                            || !bcClient
                            || usePoints
                            || loyaltyPoints <= 0
                            || loyaltyPoints === undefined
                        }
                        appliedDiscount={codeDiscountCode ? { code: codeDiscountCode, amount: codeDiscountToUse } : undefined}
                        appliedCoupon={coupon.codeVerified ? { code: String(coupon.codeVerified), amount: couponAmountToUse } : undefined}
                        appliedFidelity={usePoints ? { amount: loyaltyPointsToUse } : undefined}
                        onRemoveDiscount={this.removeCodeDiscount}
                        onRemoveCoupon={this.removeCoupon}
                        onRemoveFidelity={this.toggleUsePoints}
                        fidelityPoints={
                            loyaltyPoints <= 0
                                || loyaltyPoints === undefined
                                ? 0 : -loyaltyPoints
                        }
                        fidelityActivated={loyaltyPoints !== undefined}
                        open={openDiscountModal}
                        onClose={() => this.toggleOpenModal('openDiscountModal')}
                    />
                    <Dialog
                        open={Boolean(itemToDelete)}
                        onClose={() => this.setState({ itemToDelete: null })}
                    >
                        <div className="__cart-dialog">
                            <Title>{intl.formatMessage({ id: 'order.deleteTitle' })}</Title>
                            <p className="__cart-dialog-text">{intl.formatMessage({ id: 'order.deleteMessage' })}</p>
                            <div className="__cart-dialog-buttons">
                                <Button buttonClasses="__cart-dialog-button" containerClasses="__cart-dialog-button-container" onClick={() => this.setState({ itemToDelete: null })}>{intl.formatMessage({ id: 'cancel' })}</Button>
                                <Button buttonClasses="__cart-dialog-button-red" containerClasses="__cart-dialog-button-container" onClick={this.handleDelete}>{intl.formatMessage({ id: 'yes' })}</Button>
                            </div>
                        </div>
                    </Dialog>
                    <Snackbar
                        variant="success"
                        open={discountSuccess}
                        message={intl.formatMessage({ id: 'order.discountSuccess' })}
                        timer={2500}
                        onClose={() => this.setState({ discountSuccess: false })}
                    />
                    <Snackbar
                        variant="warning"
                        open={checkFailed}
                        message={errorMessage}
                    />
                    <Snackbar
                        variant="warning"
                        open={bookingCheckOnlyFailed}
                        message={(
                            /* eslint-disable-next-line
                            jsx-a11y/click-events-have-key-events,
                            jsx-a11y/no-static-element-interactions */
                            <span style={{ cursor: 'pointer' }} onClick={() => history.push(`/${language}/account/settings`)}>
                                {intl.formatMessage({ id: 'order.bookingCheckOnlyFailed' })}
                                <p style={{ fontWeight: 'bold' }}>{intl.formatMessage({ id: 'order.bookingCheckOnlyFailedLink' })}</p>
                            </span>
                        )}
                        timer={5000}
                        onClose={() => this.setState({ bookingCheckOnlyFailed: false })}
                    />
                    {
                        this.items.length > 0
                            ? (
                                <div className="__cart-layout">
                                    <div className="__cart-list">{formatedItems}</div>
                                    <aside className="__cart-summary-col">
                                        {this.renderSummary(checkBoxLabel, loyaltyPoints)}
                                    </aside>
                                </div>
                            )
                            : (
                                <div className="__cart-no-items-container">
                                    <Title className="__cart-no-items">{intl.formatMessage({ id: 'order.noItems' })}</Title>
                                    <Button buttonClasses="__cart-no-items-button" containerClasses="__cart-no-items-button-container" onClick={this.goHome}>
                                        {intl.formatMessage({ id: 'order.continueShop' })}
                                    </Button>
                                </div>
                            )
                    }
                </div>

                <Snackbar
                    variant="error"
                    open={displayParticipantError}
                    onClose={() => this.setState({ displayParticipantError: false })}
                    timer={5000}
                    message={intl.formatMessage({ id: 'order.nbParticipantsError' })}
                />
            </Container>
        );
    }
}

const mapStateToProps = (store: ApplicationState) => ({
    codeDiscount: store.products.codeDiscount,
    userData: store.setting.userData,
    schools: store.setting.schools,
    // GET /schools/ full objects - the only list carrying accepted_payment_methods.
    productSchools: store.products.schools,
    language: store.translation.language,
    countries: store.setting.countries,
    languages: store.setting.languages,
    bcClient: store.setting.bcClient,
    inputClient: store.setting.inputClient,
    currentSchool: store.navigation.currentSchool,
});
const connector = connect(mapStateToProps);

export default injectIntl(connector(Cart));
